import { Heading } from "@chakra-ui/react";

export default function H4({ children, ...rest }) {
  return (
    <Heading
      as="h4"
      fontWeight={600}
      fontSize="1.4rem"
      letterSpacing="0.4px"
      lineHeight="1.43"
      {...rest}
    >
      {children}
    </Heading>
  );
}
